<script lang="ts" setup>
import type { OwnerCompany } from "@/api/users/dto/owner.dto";
import { computed } from "vue";

const props = defineProps<{
  company: OwnerCompany;
}>();

const fullAddress = computed(() => {
  const { addressCity, addressState, addressZipCode, addressCountry } = props.company;

  return [addressCity, addressState && `${addressState} ${addressZipCode}`, addressCountry].filter(Boolean).join(", ");
});
</script>

<template>
  <div>
    <div class="text-grey-darken-3 font-weight-500">{{ props.company.name }}</div>

    <div class="d-flex align-center mt-3 col-gap-2">
      <v-icon class="text-grey-darken-2" size="16">mdi-map-marker-radius-outline</v-icon>
      <span class="font-size-12 text-grey-darken-1">{{ fullAddress }}</span>
    </div>
  </div>
</template>
